import React, { useEffect, useState } from "react";

function IX({ onCommisionChange, time }) {
  const [value, setValue] = useState("");
  const [fuel, setFuel] = useState("");

  const handleChangeCost = (event) => {
    const inputValue = event.target.value;

    if (/^\d*\.?\d*$/.test(inputValue)) {
      const calculatedValue = inputValue;
      setValue(calculatedValue);
      onCommisionChange(calculatedValue);
    }
  };

  const handleChangeFuel = (event) => {
    const inputFuel = event.target.value;
    // Update the fuel state
    setFuel(inputFuel);
    // let floatFuel = parseFloat(fuel);
    // let floatValue = parseFloat(value);
    // let res = floatValue + time * floatFuel;
    // console.log(floatFuel);
    // console.log(floatValue);
    // console.log(res);
    // onCommisionChange("" + res);
  };

  useEffect(() => {
    let floatFuel = parseFloat(fuel);
    let floatValue = parseFloat(value);
    let res = floatValue + time * floatFuel;
    onCommisionChange("" + res);
  }, [value, fuel]);

  return (
    <div style={{ marginLeft: "40px" }}>
      <input
        type="text"
        value={value}
        placeholder="Εισάγετε το κόστος διοδίων."
        style={{ width: "230px" }}
        onChange={handleChangeCost}
      />

      <input
        type="text"
        value={fuel}
        placeholder="Τιμές κατανάλωσης καυσίμου/εκπομπών για Ι.Χ"
        style={{ width: "230px" }}
        onChange={handleChangeFuel}
      />
    </div>
  );
}

export default IX;
